import { render, staticRenderFns } from "./EmailListingSettingsHeader.vue?vue&type=template&id=126df2be&"
import script from "./EmailListingSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./EmailListingSettingsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports